/**
 * Estilos para o componente ContainerPage.
 *
 * Este módulo contém os componentes estilizados utilizados para renderizar
 * o contêiner principal da página e seu cabeçalho.
 *
 * @module ContainerPage.Styles
 */

import styled from '@emotion/styled/macro';

/**
 * Componente estilizado para o contêiner principal da página.
 *
 * Define o layout flexível em coluna para o contêiner da página com:
 * - Display flex com direção de coluna
 * - Altura de 100%
 * - Padding interno
 * - Cor de fundo cinza claro (#f0f0f7)
 * - Box-sizing configurado para incluir padding no cálculo da altura
 *
 * Nota: Há uma configuração de altura máxima comentada que pode ser
 * descomentada se necessário para ajustar o layout.
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const StyledContainer = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  /* max-height: calc(100% - 83px); */
  padding: 2em 3em;
  background-color: #f0f0f7;
  box-sizing: border-box;
`;

/**
 * Componente estilizado para o cabeçalho do contêiner.
 *
 * Define o estilo do título da página com:
 * - Tamanho de fonte maior (1.6rem)
 * - Renderizado como um elemento span
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const HeaderContainer = styled.span`
  font-size: 1.6rem;
`;
